<template>
    <div class="video-wall">
        <p class="wall-title overHidden">
            视频墙

            <span class="fRight">
                <Button v-if="playState" class="m-r-10" type="primary" @click="suspended">全部暂停</Button>
                <Button class="m-r-10" v-else  type="primary" @click="play">全部播放</Button>
                <Button class="m-r-40" type="primary" @click="modal=true;getTreeWall()">配置</Button>
                <span class="positionRL">
                    <img :src="close" alt="" class="close-btn positionAB" @click="closeWall" style="right: 0;top: 2px">
                </span>

            </span>
        </p>
        <div class="videoCon">
            <ul class="video-list">
                <li class="list-item-wrap" v-for="(item,index) in videoList" :key="index">
                    <div class="list-item">
                        <div class="video-box">
                            <div class="item-video">
                                <div class="hello-ezuikit-js" v-if="videoType=='1'">
                                    <div :id="'video_'+item.id" style="width:100%;height:100%"></div>
                                </div>
                                <div v-else-if="videoType=='2'">
                                  <hk-video v-if="videoType=='2' && item.hlsAddr" :previewUrl="item.hlsAddr" :VWidth="'600'" :VHeight="'300'" :videoId="videoSid" :channelNum="channelNum" :sid="videoSid"></hk-video>
                                </div>
                                <div v-else-if="videoType=='4'">
                                  <h5-video v-if="videoType=='4' && item.hlsAddr" :previewUrl="item.hlsAddr" :VWidth="'600'" :VHeight="'300'" :videoId="videoSid" :channelNum="channelNum" :sid="videoSid"></h5-video>
                                </div>
                                <div v-else-if="videoType == '5'">
                                  <videoPlay
                                    v-if="videoType == '5' && item.hlsAddr"
                                    :previewUrl="item.hlsAddr"
                                    :videoId="998"
                                    :channelNum="channelNum"
                                    :videoSid="videoSid"
                                    :videoDeviceId="item.id"
                                    :height="300"
                                    :width="600"
                                    :showClose="false"
                                  />
                                </div>
                                <video
                                        :id="'video_'+item.id"
                                        class="video-js vjs-default-skin"
                                        muted
                                        v-else
                                >
                                    <source :src="item.hlsAddr"/>
                                </video>
                            </div>
                            <div v-show="!playState" class="cover">
                                <img v-if="item.thumbAddr" :src="item.thumbAddr">
                                <img v-else :src="iconcamera">
                            </div>
                        </div>
                        <div class="item-title-box">
                            <div class="item-title">
                                <p style="font-weight:bold; font-size:14px;" :title="item.name">名称：{{item.name}}</p>
                            </div>
                            <div class="item-title" style="color:#999;">
                                <p :title="item.orgName">单位：{{item.orgName}}</p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="arrow arrowLeft" v-if="page.currentPage != 1" @click="getPageData(1)">
                <Icon type="ios-arrow-back" size="38" color="#00eff3"/>
            </div>
            <div class="arrow arrowRight" @click="getPageData(2)" v-if="page.currentPage != page.totalPage && page.totalPage != 0">
                <Icon type="ios-arrow-forward" size="38" color="#00eff3"/>
            </div>
        </div>
        <Modal
                title="视频墙配置"
                v-model="modal"
                :mask-closable=false
                class-name="show-tree"
        >
            <!--<Row :gutter="16">-->
            <!--<Col span="10">-->
            <!--<Input v-model="keyword" icon="ios-search" placeholder="摄像头名称模糊搜索"></Input>-->
            <!--</Col>-->
            <!--</Row>-->
            <div style="height: 400px;overflow: auto">
                <Tree class="m-t-30" :data="authTree" show-checkbox @on-check-change="changeTree"></Tree>
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="modal = !modal">取消</Button>
                <Button type="primary" size="large" @click="saveSettings">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
  import close from '@/assets/img/close.png';
  import iconcamera from '@/assets/img/iconcamera.png';
  import EZUIKit from "ezuikit-js";
  import videoPlay from './videoPlay/videoPlay'
  import hkVideo from "./videoPlay/hkVideo/hkVideo";
  import h5Video from "./videoPlay/h5Video/h5Video";
  //引入video.js
  import videojs from 'video.js'
  import 'video.js/dist/video-js.css'
  export default {
    name: "video-wall",
    data: () => ({
      close,
      iconcamera,
      playState: true,
      accessToken: '',
      videoList: [],
      page: {
        totalPage: 0,
        pageSize: 12,
        currentPage: 1
      },
      videoPlayerList: {},
      ezopenPlayer: {},
      modal: false,
      keyword: '',
      authTree: [],
      selectedDate: [],
      timing:null,
      videoType: "1"
    }),
    created() {
      this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
      this.getToken()
      this.time()
    },
    components: {
      hkVideo,
      h5Video,
      videoPlay
    },
    methods: {
      closeWall(){
        if(this.timing) {
          clearTimeout(this.timeout);
        }
        this.videoDispose()
        this.$emit("shipinStatus", false);
      },

      getToken(){
        var data = {
          type: 'get',
          url: `/mcbw/cameras/token`,
          obj: {}
        };
        this.$Axios(data).then((res) => {
          if (res.data.success) {
            this.accessToken = res.data.data
            this.getList()
          }
        })
      },
      getList(type) {
        let dataObj = {
          type: 'get',
          url: '/mcbw/cameras/wall',
          obj: {
            "pageSize":this.page.pageSize,
            "currentPage":this.page.currentPage,
            "orgId":this.loginData.orgId,
            "cameraWallFlag":1,
          }
        }
        this.$Axios(dataObj).then((res)=>{
          if(res.data.success){
            if(res.data.data.length > 0){
              res.data.data.forEach(item => {
                this.videoList = res.data.data
                this.playVideo('video_' + item.id, item.hlsAddr)
              })
              this.page.totalPage = Math.ceil(res.data.totalCount / this.page.pageSize)
            }else{
              if(!type) {
                this.modal = true
                this.getTreeWall()
                this.page.totalPage = 0
              }
            }
          }
        });
      },
      getTreeWall() {
        let dataObj = {
          type: 'get',
          url: '/mcbw/cameras/tree/wall',
          obj: {
            "orgId":this.loginData.orgId,
          }
        }
        this.$Axios(dataObj).then((res)=>{
          if(res.data.success){
            let arr = []
            this.authTree = res.data.data;
            res.data.data.forEach((item, index) => {
              item.children.forEach((items, index1) => {
                if (items.checked == 1) {
                  arr.push(items)
                }
              });
            });
            this.selectedDate = arr
          }
        });
      },
      playVideo(id, url) {
        this.$nextTick(() => {
          if (url && url.includes('ezopen')) {
            this.videoType = "1";
            this.ezopenPlayer[id] = new EZUIKit.EZUIKitPlayer({
              autoplay: true,
              id: id,
              accessToken: this.accessToken,
              url,
              template: "simple", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
              // 视频上方头部控件
              //header: ["capturePicture", "save", "zoom"], // 如果templete参数不为simple,该字段将被覆盖
              //plugin: ['talk'],                       // 加载插件，talk-对讲
              // 视频下方底部控件
              // footer: ["talk", "broadcast", "hd", "fullScreen"], // 如果template参数不为simple,该字段将被覆盖
              // audio: 1, // 是否默认开启声音 0 - 关闭 1 - 开启
              // openSoundCallBack: data => console.log("开启声音回调", data),
              // closeSoundCallBack: data => console.log("关闭声音回调", data),
              // startSaveCallBack: data => console.log("开始录像回调", data),
              // stopSaveCallBack: data => console.log("录像回调", data),
              // capturePictureCallBack: data => console.log("截图成功回调", data),
              // fullScreenCallBack: data => console.log("全屏回调", data),
              // getOSDTimeCallBack: data => console.log("获取OSDTime回调", data),
              width: 387,
              height: 232
            });
          } else if(url && url.includes('rtsp://')){
              this.videoType = "2";
          } else  if(url.includes('ws://') || url.includes('wss://')){
              this.videoType = "4";
          } else if (url && url.includes('http')) {
            this.$nextTick(() => {
              this.videoType = "3";
              let parentNode = document.getElementById(id).parentNode;
              let width = parentNode.offsetWidth;
              let height = parentNode.offsetHeight;
              if (!this.videoPlayerList.hasOwnProperty(id)) {
                this.videoPlayerList[id] = videojs(id, {
                  src: url,
                  muted: true,
                  autoplay: true,
                  controls: false,
                  height: height,
                  width: width,
                }, function () {
                  videojs.log('播放器已经准备好了!');
                });
              } else {
                this.videoPlayerList[id].play()
              }
            })
          }
        })
        this.playState = true
      },
      //继续播放
      play() {
        if (JSON.stringify(this.videoPlayerList) != "{}") {
          for (let key in this.videoPlayerList) {
            this.videoPlayerList[key].play();
          }
        }
        if (JSON.stringify(this.ezopenPlayer) != "{}") {
          for (let key in this.ezopenPlayer) {
            this.ezopenPlayer[key].play()
          }
        }
        this.playState = true
        this.time()
      },

      //暂停播放
      suspended() {
        if (JSON.stringify(this.videoPlayerList) != "{}") {
          for (let key in this.videoPlayerList) {
            this.videoPlayerList[key].pause();
          }
        } else {
          console.log('未找到videoPlayerList实例');
        }

        if (JSON.stringify(this.ezopenPlayer) != "{}") {
          for (let key in this.ezopenPlayer) {
            this.ezopenPlayer[key].stop()
          }
        } else {
          //未找到video实例
          console.log('未找到ezopenPlayer实例');
        }
        this.playState = false
        if(this.timing) {
          clearTimeout(this.timeout);
        }
      },

      //销毁播放
      videoDispose() {
        if (JSON.stringify(this.videoPlayerList) != "{}") {
          for (let key in this.videoPlayerList) {
            console.log(key);
            this.videoPlayerList[key].dispose();
          }
        } else {
          console.log('未找到videoPlayerList实例');
        }


        if (JSON.stringify(this.ezopenPlayer) != "{}") {
          for (let key in this.ezopenPlayer) {
            console.log(key);
            this.ezopenPlayer[key] = null
          }
          //销毁成功


          console.log(this.ezopenPlayer);
        } else {
          //未找到video实例
          console.log('未找到ezopenPlayer实例');
        }

        if(this.timing) {
          clearTimeout(this.timeout);
        }
      },
      saveSettings() {
        let arr = []
        this.selectedDate.forEach((item, index) => {
          if (item.id) {
            arr.push(item.id)
          }
        });

        let dataObj = {
          type: 'put',
          url: '/mcbw/cameras/wall',
          obj: {
            "orgId":this.loginData.orgId,
            "cameraIds": arr.toString(),
          }
        }
        this.$Axios(dataObj).then((res)=>{
          if(res.data.success){
            this.$Message.success(res.data.message);
            this.modal = false
            this.videoList = []
            for (let key in this.videoPlayerList) {
              this.videoPlayerList[key].dispose();
              delete this.videoPlayerList[key]
            }
            for (let key in this.ezopenPlayer) {
              this.ezopenPlayer[key] = null
              delete this.ezopenPlayer[key]
            }
            if(this.timing) {
              clearTimeout(this.timeout);
            }
            this.time()
            this.page.currentPage = 1
            this.getList(1)
          }
        });
      },//处理菜单id 拼接成字符串
      changeTree(val){
        this.selectedDate = val
      },

      getPageData(val) {
        if(val == 1){
          this.page.currentPage --
        }else if(val == 2){
          this.page.currentPage ++
        }
        this.videoList = []
        for (let key in this.videoPlayerList) {
          this.videoPlayerList[key].dispose();
          delete this.videoPlayerList[key]
        }
        for (let key in this.ezopenPlayer) {
          this.ezopenPlayer[key] = null
          delete this.ezopenPlayer[key]
        }
        this.getList();
      },

      time() {
        let self = this
        self.timing = setTimeout(() => {
          self.suspended()
          self.playState = false
        }, 3600000)
      }
    }
  }
</script>

<style lang="scss" scoped>
.video-wall{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: calc(100vh - 87px);
    padding: 10px 20px;
    background: #012C44;
    z-index: 160;
    .wall-title{
        color: #00eff3;
        font-size: 16px;
        padding-bottom: 10px;
        padding-left: 10px;
        border-bottom: 1px solid #03697a;
        .close-btn{
            width: 15px;
            height: 15px;
            cursor: pointer;
        }
    }
    .videoCon{
        position: relative;
        .video-list {
            display: flex;
            flex-wrap: wrap;
            list-style: none;
            .list-item-wrap {
                width: 25%;
                padding: 15px 10px 10px;
                .list-item {
                    border: 1px solid #eee;
                    border-radius: 10px;
                    overflow: hidden;
                    /*transition: all .2s ease-in-out;*/
                    box-shadow: 0 0 2px rgba(0, 0, 0, .2);
                    /*&:hover{*/
                    /*transform: scale(1.1);*/
                    /*}*/
                    .video-box {
                        position: relative;
                        height: 0;
                        padding-top: 60%;
                        overflow: hidden;
                        background: #f9f9f9;

                        .cover {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            overflow: hidden;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        video {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            object-fit: fill;
                            background: #333;
                        }
                        .item-video {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .item-title-box {
                        padding: 5px 0;
                        .item-title {
                            display: flex;
                            justify-content: space-between;
                            padding: 0 10px;
                            p {
                                max-width: 50%;
                                height: 24px;
                                line-height: 24px;
                                font-size: 12px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                transform: translate3d(0, 0, 0);
                            }
                        }
                    }
                }
            }
        }
        .arrow{
            position: absolute;
            width: 50px;
            height: 50px;
            background: rgba(236,236,236,0.5);
            border-radius: 30px;
            line-height: 50px;
            text-align: center;
            cursor: pointer;
            padding-top: 4px;
        }
        .arrowLeft{
            position: absolute;
            left: 0;
            top: 370px;
        }
        .arrowRight{
            position: absolute;
            right: 0;
            top: 370px;
        }
    }
}

/deep/ .show-tree {
    .ivu-modal-content{
        background: #012c44;
        .ivu-modal-header{
            border-bottom: 0.5px solid #316e70;
        }
        .ivu-modal-header-inner{
            color: #00e6eb !important;
        }
        .ivu-modal-body {
            color: #00e6eb !important;
            .ivu-tree-title{
                color: #00e6eb !important;
            }
            .ivu-checkbox-inner{
                background: #012c44;
            }
        }
        .ivu-modal-footer{
            border-top: 0.5px solid #316e70;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/video-wall.vue